const { render, useState } = wp.element;
import React, { Component } from 'react';
import { withTranslation } from "react-i18next";
import { connect } from 'react-redux';

//Import Designs
import { Grid2, IconButton } from '@mui/material';
import LinkIcon from '@mui/icons-material/Link';
import AspectRatioIcon from '@mui/icons-material/AspectRatio';

import Showallpopup from './Showallpopup.jsx';

class Showallactions extends Component {
    constructor(props) {
        super(props);
        this.state = { anchor_btn: '', anch_font: '', link_btn: '', link_fnt: '', modalopen: false };
    }

    componentDidMount = () => {
        if (typeof this.props.settings === "object") {
            const { votes_button_font_color, votes_button_bgcolor } = this.props.settings.color;

            this.setState({
                anch_font: votes_button_font_color,
                anchor_btn: votes_button_bgcolor,
                link_font: votes_button_font_color,
                link_btn: votes_button_bgcolor
            })
        }
    }

    toggleHovertwo = (value, val, name) => () => {
        if (name == 'anchr_button')
            this.setState({ anch_font: value, anchor_btn: val })
        else
            this.setState({ link_font: value, link_btn: val })
    }

    toggleleavetwo = (value, val, name) => () => {
        if (name == 'anchr_button')
            this.setState({ anch_font: value, anchor_btn: val })
        else
            this.setState({ link_font: value, link_btn: val })
    }

    handlepopup = () => {
        this.setState({ modalopen: true });
    }

    handleClose = (event) => {
        this.setState({ modalopen: false });
    }

    render() {
        const { votes_button_font_size, votes_button_font_color, votes_button_font_color_hover, votes_button_bgcolor, votes_button_bgcolor_hover } = this.props.settings.color;
        const allprops = this.props;
        const post_index = this.props.indexpost;

        return (
            (<React.Fragment>
                <Grid2 size={4}>
                    <IconButton
                        color="primary"
                        style={{ fontSize: votes_button_font_size + 'px', 'color': this.state.anch_font, 'background': this.state.anchor_btn }}
                        onMouseOver={this.toggleHovertwo(votes_button_font_color_hover, votes_button_bgcolor_hover, 'anchr_button')}
                        onMouseLeave={this.toggleleavetwo(votes_button_font_color, votes_button_bgcolor, 'anchr_button')}
                        href={this.props.singlepost.link}
                    >
                        <LinkIcon />
                    </IconButton>
                </Grid2>
                <Grid2 size={4}>
                    <IconButton
                        color="primary"
                        style={{ fontSize: votes_button_font_size + 'px', 'color': this.state.link_font, 'background': this.state.link_btn }}
                        onMouseOver={this.toggleHovertwo(votes_button_font_color_hover, votes_button_bgcolor_hover, 'link_button')}
                        onMouseLeave={this.toggleleavetwo(votes_button_font_color, votes_button_bgcolor, 'link_button')}
                        onClick={() => this.handlepopup()}
                    >
                        <AspectRatioIcon />
                    </IconButton>
                </Grid2>
                <Showallpopup {...allprops}
                    post={this.props.singlepost}
                    open_val={this.state.modalopen}
                    handlemodal={this.handleClose}
                    post_index_val={post_index}
                />
            </React.Fragment>)
        );

    }
}

export default connect()(withTranslation("translations")(Showallactions));